import * as React from "react";
import { forwardRef } from "react";
const SvgPause = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("mask", { id: "mask0_290_7763", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 18, height: 18 }, /* @__PURE__ */ React.createElement("rect", { width: 18, height: 18, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_290_7763)" }, /* @__PURE__ */ React.createElement("path", { d: "M10.5 13.875V4.125H13.3125V13.875H10.5ZM4.6875 13.875V4.125H7.5V13.875H4.6875Z" })));
const ForwardRef = forwardRef(SvgPause);
export { ForwardRef as ReactComponent };
